export default {
  getIdentifyCode: state => state.identifyCode,
  getUser: state => state.user,
  getUnreadCount: state => state.unread_count
}


// WEBPACK FOOTER //
// ./src/vuex/getters.js